import { render, staticRenderFns } from "./QR_CODE.vue?vue&type=template&id=5841ce02&scoped=true&"
import script from "./QR_CODE.vue?vue&type=script&lang=js&"
export * from "./QR_CODE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5841ce02",
  null
  
)

export default component.exports